import * as React from 'react';
import { clsx } from 'clsx';
import { NumberInput } from '@cian/ui-kit';

import { Text } from '../Text';

import { mergeStyles } from '@cian/utils';
import * as styles from './InputsMultiple.css';

interface IInputProps extends React.HTMLProps<HTMLInputElement> {
  onChangeValue(value: string): void;
}

export interface IInputsMultipleProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  stack: IInputProps[];
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export function InputsMultiple(props: IInputsMultipleProps) {
  const { stack, label } = props;

  const [focusedInputIndex, setFocusedInputIndex] = React.useState(-1);
  const [hoveredInputIndex, setHoveredInputIndex] = React.useState(-1);

  return (
    <div {...mergeStyles([styles['field']])}>
      <div className={styles['label']}>
        <Text fontSize={14} lineHeight={18}>
          {label}
        </Text>
      </div>
      <div className={styles['stack']}>
        {stack.map((stackProps, index) => {
          const handleChange = (value?: number) =>
            stackProps.onChangeValue(typeof value === 'number' ? value.toString() : '');

          const isActive = index === focusedInputIndex || index === hoveredInputIndex;

          return (
            <span key={index} className={clsx(styles['item'], isActive && styles['active'])}>
              <NumberInput
                disabled={props.disabled}
                placeholder={stackProps.placeholder}
                value={stackProps.value ? Number(stackProps.value) : undefined}
                aria-label={stackProps['aria-label']}
                onChange={handleChange}
                onFocus={() => setFocusedInputIndex(index)}
                onBlur={() => setFocusedInputIndex(-1)}
                onMouseEnter={() => setHoveredInputIndex(index)}
                onMouseLeave={() => setHoveredInputIndex(-1)}
              />
            </span>
          );
        })}
      </div>
    </div>
  );
}
